const createCameraInput = (handleFiles: (files: File[]) => void) => {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = 'image/*';
  input.capture = 'environment';
  input.onchange = (event) => {
    const files = Array.from((event.target as HTMLInputElement).files || []);
    handleFiles(files);
  };
  return input;
};

const createFileInput = (handleFiles: (files: File[]) => void) => {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = '.pdf,.doc,.docx,.txt,.jpg,.jpeg,.png,.gif';
  input.multiple = true;
  input.onchange = (event) => {
    const files = Array.from((event.target as HTMLInputElement).files || []);
    handleFiles(files);
  };
  return input;
};

export const createAttachmentUploadHandlers = (
  onFiles: (files: File[]) => void
) => {
  const handleCameraCapture = () => {
    const input = createCameraInput(onFiles);
    input.click();
  };

  const handleFileAttachment = () => {
    const input = createFileInput(onFiles);
    input.click();
  };

  return { handleCameraCapture, handleFileAttachment };
};
